import styled from "styled-components";
import { motion } from "framer-motion";

export const BioWithImageAndQuoteWrapper = styled(motion.div)`
  height: calc(100vh - 5vmin);
  // margin-top: 5vmin;
  background: black;
  color: white;
`;

export const Quote = styled(motion.div)`
  font-family: "MFred";
  font-size: 8rem;
  margin-bottom: -1rem;
  line-height: 0;
`;
